import { ButtonKind, Modal, PanoramaButton } from 'shared-ui/components'
import { useLocalization } from 'shared-ui/localization'
import { isNonNil } from 'utils'

/**
 * Shown before creating a boundary for a field that already has one. Forces the
 * user to choose intentionally between adding a second boundary, replacing the
 * existing one(s), or backing out. "Replace" deletes the existing boundaries and
 * then creates the new one.
 */
export const ConfirmAdditionalBoundaryModal = ({
  show,
  existingCount,
  onCreateAnother,
  onReplace,
  onCancel,
  pending = false,
  error
}: {
  show: boolean
  existingCount: number
  onCreateAnother: () => void
  onReplace: () => void
  onCancel: () => void
  pending?: boolean
  error?: string
}) => {
  const { t } = useLocalization()

  return (
    <Modal
      title={t(($) => $.planning.boundaryCreation.confirmAdditional.title)}
      show={show}
      onClose={onCancel}
    >
      <p className="mb-6 mt-4 text-sm text-gray-600">
        {t(($) => $.planning.boundaryCreation.confirmAdditional.body, { count: existingCount })}
      </p>
      {isNonNil(error) && <p className="mb-4 text-sm text-red-500">{error}</p>}
      <div className="flex flex-col gap-2">
        <PanoramaButton
          onClick={onCreateAnother}
          disabledWhen={{ when: pending, reason: t(($) => $.disabledReasons.actionInProgress) }}
        >
          {t(($) => $.planning.boundaryCreation.confirmAdditional.createAnother)}
        </PanoramaButton>
        <PanoramaButton kind={ButtonKind.Danger} onClick={onReplace} loading={pending}>
          {t(($) => $.planning.boundaryCreation.confirmAdditional.replace)}
        </PanoramaButton>
        <PanoramaButton
          kind={ButtonKind.Secondary}
          onClick={onCancel}
          disabledWhen={{ when: pending, reason: t(($) => $.disabledReasons.actionInProgress) }}
        >
          {t(($) => $.buttons.cancel)}
        </PanoramaButton>
      </div>
    </Modal>
  )
}
